import { Duration } from "@tento-chrono";
import { Storybook } from "@tento-ui/ui/storybook";
import { Timer } from "@tento-ui/components/timer/timer";
import { LonaTimerPage } from "./timer-page";

export class LonaTimerPageStoryBook extends Storybook.Default {
  title(): string {
    return "Timer Page";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Focus Timer",
        render: () => {
          const duration = Duration.Time.mins(25);
          return LonaTimerPage.make()
            .assignStyles({
              width: "100%",
              maxWidth: "400px",
              height: "300px",
            })
            .bind({
              timer: Timer.make(duration),
              duration,
              color: "var(--red)",
              label: "Focus",
              identifier: "pomodoro",
            });
        },
      },
      {
        title: "Short Break",
        render: () => {
          const duration = Duration.Time.mins(5);
          return LonaTimerPage.make()
            .assignStyles({
              width: "100%",
              maxWidth: "400px",
              height: "300px",
            })
            .bind({
              timer: Timer.make(duration),
              duration,
              color: "var(--green)",
              label: "Short Break",
              identifier: "shortBreak",
            });
        },
      },
    ];
  }
}
